import Autocomplete from '@mui/material/Autocomplete';

import { SearchField } from './SearchField';
import type { SearchAutocompleteFieldProps } from './types';

export const SearchAutocompleteField = (props: SearchAutocompleteFieldProps) => {
  const { disabled, value, hints, sx, setInputValue, onClear, ...restOfProps } = props;

  const handleChange = (_: React.SyntheticEvent, value: string | null) => {
    setInputValue?.(value ?? '');
  };

  return (
    <Autocomplete
      fullWidth
      disableClearable
      disabled={disabled}
      sx={sx}
      value={value}
      inputValue={value}
      openOnFocus={false}
      options={hints || []}
      onChange={handleChange}
      renderInput={params => (
        <SearchField
          {...params}
          {...restOfProps}
          fullWidth
          value={value}
          onClear={onClear}
          inputProps={{ ...params.inputProps }}
        />
      )}
    />
  );
};
